import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { IonModal, ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { PayWallComponent } from './components/pay-wall/pay-wall';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { Events } from './Events.service';



@Injectable({
  providedIn: 'root'
})
export class PaywGuard implements CanActivate {
  constructor( private router:Router,private modal:ModalController, private events:Events,private appConfig:AppConfigService)
  {}
  payWallModal;
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> | boolean  {
      //return this.payWallPromise();
      if (this.appConfig.featureAvailable('synth'))
      return true;
      if (Capacitor.getPlatform()=='web')
      return true;
      else
      {
        return this.payWallPromise();
        
      }
    }
    updateEvent;
    payWallPromise():Promise<boolean>
    {

      // monitor store progress 
     
      let newP=new Promise<boolean> ((resolve,reject)=>{

        let par=this;

        this.updateEvent=this.events.get("appconfig:store");

        this.updateEvent.subscribe(
        ()=>{
              if (this.appConfig.featureAvailable('synth'))
            {
              if (this.modal)
              this.modal.dismiss();
              resolve(true);
  
            }
          }
          );

let paywallCb=(action)=>
{
  if (action=='subscribe')
 {
  par.payWallModal.dismiss();
  par.router.navigate(['/purchase'])
  resolve(false)
 }
 if (action=='freeaccess')
 {
  par.appConfig.accesss48Selected=true;
  if (Capacitor.getPlatform()=='web')
  {
  resolve(true);
  this.payWallModal.dismiss();
  }
  else
  if (par.appConfig.access48())
  {
    par.payWallModal.dismiss();
    resolve(true);
  }
  else
  {
  alert("Not illgible for free access");
  resolve(false)
  }

 }

 if (action=='exitApp')
 {
  if (this.appConfig.app)
    {
      this.appConfig.app.exitApp();

    }
    resolve(false)

  
  }
  
}// end of function

        if (this.payWallModal)
        {
            this.payWallModal.present();
          
        }
        else
        {
           this.modal.create({
              component:PayWallComponent,
          componentProps:{
            action:paywallCb.bind(this)
          }})
          .then ((modal)=>{
            this.payWallModal=modal;
            modal.present();
      
          });
         
          }
        });
            
          
          return (newP)
        }
      


      
      
    
  }
  

